export enum DataTestIds {
    SIDE_MENU = 'side-menu',
    TOP_BAR_WRAPPER = 'top-bar-wrapper',
    TOP_LEVEL_METRICS = 'top-level-metrics',
    OVERVIEW = 'overview',
    CREATIVE_GALLERY = 'creative-gallery',
    PERFORMANCE_OVER_TIME = 'performance-over-time',
    PERFORMANCE_MAP = 'performance-map',
    CONTENT_CATEGORY_BREAKDOWN = 'content-category-breakdown',
    INVENTORY_QUALITY = 'inventory-quality',

    COUNTRIES_FILTER = 'countries-filter',
    DEVICE_FILTER = 'device-filter',
    DATE_PICKER = 'date-picker',

    MY_BRAND_CHIP = 'my-brand-chip',
    USER_PROFILE_BUTTON = 'sidebar-user-menu-button',

    CAMPAIGNS_CONTENT_CATEGORY = 'campaigns-content-category',
    CAMPAIGNS_LOWEST_SITES = 'campaigns-lowest-sites',
    CAMPAIGNS_REFRESH_RATE = 'campaigns-refresh-rate',

    SPEND_EFFICIENCY = 'spend-efficiency',
    PERFORMANCE_BY_TIME = 'performance-by-time',
    PERFORMANCE_BY_DEVICE = 'performance-by-device',
    SHARE_OF_VOICE = 'share-of-voice',
    PERFORMANCE_COMPARISON = 'performance-comparison',
    CONTENT_CATEGORY_DISTRIBUTION = 'content-category-distribution',
    POLARIS_PROGRESS_BAR = 'polaris-progress-bar',
    AUDIENCE_GENDER = 'audience-gender',
}
